import {AbstractService} from 'services/AbstractService';

const AUTH_URL = '/api/auth';
const RESTORE_PASSWORD_URL = '/api/password';
const RESET_PASSWORD_URL = '/api/password/{0}';
const CURRENT_USER_DETAILS_URL = '/api/me';
const FINISH_QUICKSTART_URL = '/api/me/quickstart/finish';
const USER_ROLE_URL = '/api/me/role';
const USER_PERMISSIONS_URL = '/api/me/role/permissions';
const USER_NOTES_URL = '/api/usernotes';
const TOKEN_TEST_URL = '/api/password/{0}';
const IMPORTANT_ITEMS_URL = '/api/me/important';
const CURRENT_USER_META_URL = '/api/me/meta';

export class UserService extends AbstractService {

  authorizeUser (email, password, remember) {
    return this.client.put(AUTH_URL, {
      email,
      password,
      ttl: remember ? 720 : 24
    });
  }

  resetPassword (token, password) {
    return this.client.put(
      RESET_PASSWORD_URL.format(token),
      {
        password,
        ttl: 24
      }
    );
  }

  requestPasswordRestore (email) {
    return this.client.post(RESTORE_PASSWORD_URL, {
      email
    });
  }

  testToken (token) {
    return this.client.get(TOKEN_TEST_URL.format(token));
  }

  getCurrentUser () {
    return this.client.get(CURRENT_USER_DETAILS_URL);
  }

  getUserNotes () {
    return this.client.get(USER_NOTES_URL);
  }

  saveUserNotes (notes, axiosParams = {}) {
    return this.client.post(USER_NOTES_URL, notes, {}, axiosParams);
  }

  quickstartFinish (axiosParams = {}) {
    return this.client.put(FINISH_QUICKSTART_URL, {}, {}, axiosParams);
  }

  getUserRole (accountId) {
    return this.client.get(USER_ROLE_URL, {}, {accountId});
  }

  getUserPermissions (accountId) {
    return this.client.get(USER_PERMISSIONS_URL, {}, {accountId});
  }

  getMeta () {
    return this.client.get(CURRENT_USER_META_URL);
  }

  setMeta (payload) {
    return this.client.put(CURRENT_USER_META_URL, {meta: payload});
  }

  getImportantItems (axiosParams = {}) {
    return this.client.get(IMPORTANT_ITEMS_URL, {}, {}, axiosParams);
  }

  saveImportantItems (items) {
    return this.client.post(IMPORTANT_ITEMS_URL, {items});
  }
}
